import { createAction, props } from '@ngrx/store';

export const dummyAction = createAction('bcp-dummy');

export const loadBcps = createAction(
  '[BCP] Load BCPs',
  props<{ options: any }>()
);
export const loadBcpsSuccess = createAction(
  '[BCP] Load BCPs Success',
  props<{ bcps: any[]; count: number }>()
);
export const deleteBcpSuccess = createAction(
  '[BCP] Delete BCPs Success',
  props<{ id: number }>()
);

export const loadBcpRecoveryPhase = createAction(
  '[BCP] Load Bcp RecoveryPhase',
  props<{ id: number }>()
);
export const loadBcpRecoveryPhaseAll = createAction(
  '[BCP] Load Bcp RecoveryPhase All',
  props<{ id: number }>()
);
export const loadBcpRecoveryPhaseSuccess = createAction(
  '[BCP] Load Bcp RecoveryPhase Success',
  props<{ recoveryPhases: any[] }>()
);

export const deleteRecoveryPhase = createAction(
  '[BCP] Delete Recovery Phase Delete',
  props<{ id: number }>()
);
export const deleteRecoveryPhaseSuccess = createAction(
  '[BCP] Delete Recovery Phase Delete Success',
  props<{ id: number }>()
);
export const loadBcpScenarios = createAction(
  '[BCP] Load BCP Scenario',
  props<{ bcpId: any }>()
);
export const loadBcpScenariosSuccess = createAction(
  '[BCP] Load BCP Scenario Success',
  props<{ scenarios: any }>()
);

export const createBcpScenarios = createAction(
  '[BCP] Create BCP Scenario',
  props<{ bcpId: any; scenario: any }>()
);

export const updateBcpScenarios = createAction(
  '[BCP] Update BCP Scenario',
  props<{ bcpId: any; id: any; scenario: any }>()
);

export const loadStaffRequirements = createAction(
  '[BCP] Load BIA Staff requirement',
  props<{ biaIds: number[]; locationId?: number }>()
);

export const loadStaffRequirementsSuccess = createAction(
  '[BCP] Load BIA Staff requirement success',
  props<{ records: any[]; payload: any }>()
);

// #region ADDITIONAL INFORMATION
// LOAD
export const loadAdInfo = createAction(
  '[BCP] Load AdInfo',
  props<{ id: number }>()
);
export const loadAdInfoSuccess = createAction(
  '[BCP] Load AdInfo Success',
  props<{ id: number; adInfoes: any }>()
);
// ADD BIA
export const addOrUpdateAdInfo = createAction(
  '[BCP] Add or Update AdInfo',
  props<{ id: number; adInfo: any }>()
);
export const addOrUpdateAdInfoSuccess = createAction(
  '[BCP] Add or Update AdInfo Success',
  props<{ id: number; adInfo: any }>()
);
//#endregion
